<template>
  <div class="ap-field">
    <label>{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-tax-wrap">
      <span class="ap-tax-prefix">{{ prefix }}</span>
      <span class="ap-tax-sep"></span>
      <input
        :value="localNumber"
        type="tel"
        :placeholder="placeholder"
        class="ap-tax-num"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrefixInput',
  props: {
    value: { type: [Object, String], default: null },
    prefix: { type: String, default: 'E' },
    label: { type: String, default: 'Number' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: 'e.g. 0012345678' }
  },
  computed: {
    localNumber () {
      if (!this.value) return ''
      if (typeof this.value === 'object') return this.value.number || ''
      const v = this.value
      return v.startsWith(this.prefix) ? v.slice(this.prefix.length) : v.replace(/\D/g, '')
    }
  },
  methods: {
    onInput (e) {
      const digits = e.target.value.replace(/\D/g, '')
      this.$emit('input', { prefixed: this.prefix, number: digits })
    }
  }
}
</script>
